var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoedit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.486,
    height: 24.486,
    viewBox: "0 0 24.486 24.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.999,
    height: 0.999,
    transform: "translate(1.498 1.498)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.999,
    height: 0.999,
    transform: "translate(2.996 1.498)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.999,
    height: 0.999,
    transform: "translate(4.494 1.498)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1V19.167H8.9V17.193a.4.4,0,0,1,.395-.395h3.664L16.4,14.731V16.8h6.319a.4.4,0,0,1,.395.395V24.3a.4.4,0,0,1-.395.395H9.294A.4.4,0,0,1,8.9,24.3V19.957h-.79V24.3a1.186,1.186,0,0,0,1.185,1.185H22.722A1.186,1.186,0,0,0,23.907,24.3V19.167h1.58V1Zm23.7.79V4.16H1.79V1.79ZM8.182,16.8H3.37V12.848H9.689v3.16H9.294A1.183,1.183,0,0,0,8.182,16.8Zm15.725,1.58V17.193a1.186,1.186,0,0,0-1.185-1.185H17.193V13.336l-4.454,2.672h-2.26V12.058H2.58v5.529H8.109v.79H1.79V4.949H24.7V18.377Z",
    transform: "translate(-1 -1)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,49.4l6.017-3.009L32,43.382Zm.79-4.739,3.461,1.731L32.79,48.121Z",
    transform: "translate(-19.757 -26.644)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,20.109h9.479V13H35Zm.79-6.319h7.9v5.529h-7.9Z",
    transform: "translate(-21.572 -8.261)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.999,
    height: 0.999,
    transform: "translate(20.473 9.488)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.993,
    height: 0.999,
    transform: "translate(14.98 9.488)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.491,
    height: 0.499,
    transform: "translate(14.98 7.989)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,18.529h7.9V13H5Zm.79-4.739h6.319v3.949H5.79Z",
    transform: "translate(-3.42 -8.261)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.491,
    height: 0.499,
    transform: "translate(14.98 6.491)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoedit);
export default __webpack_public_path__ + "static/media/videoedit.b142aa07.svg";
export { ForwardRef as ReactComponent };